var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("mds-empty-state", {
    attrs: {
      title: _vm.translate(_vm.emptyState.title),
      message: _vm.translate(_vm.emptyState.message),
    },
    scopedSlots: _vm._u([
      {
        key: "mds-empty-state-actions",
        fn: function () {
          return [
            _vm.emptyState.button
              ? _c(
                  "mds-button",
                  {
                    attrs: {
                      size: "medium",
                      variation: "secondary",
                      icon: _vm.buttonIcon,
                    },
                    on: { click: _vm.handleClick },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.translate(_vm.emptyState.button)) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }